<template>
  <div>
    <h3>
      充值记录
    </h3>
    <div class="incomebox">
      <div class="choosetime clearfix">
        <p class="fl userinfo">
          账户余额：{{ userInfo.yuanBi }} 源币 | {{ userInfo.coin }} 赠币
        </p>
        <button class="inquirebtn defaultbtn fr" @click="timeBtn">
          查询
        </button>
        <div class="fr">
          <span class="demonstration"> 起止时间：</span>
          <el-date-picker
            v-model="allChoooseTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" class="table-cell">
        <el-table-column prop="id" align="center" label="订单号" width="180">
        </el-table-column>
        <el-table-column prop="channelName" align="center" label="充值渠道">
        </el-table-column>
        <el-table-column prop="money" align="center" label="充值金额">
        </el-table-column>
        <el-table-column prop="yuanBi" align="center" label="获得源币">
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="180"
          align="center"
          label="提交时间"
        >
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态">
        </el-table-column>
      </el-table>

      <el-pagination
        :hide-on-single-page="true"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :pager-count="pageCount"
        class="paginnation-book"
        :current-page="Current"
        @current-change="currentChoose"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { payOrder } from "apiurl/pay";
import { getuserInfo } from "@/api/login";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      allChoooseTime: [],
      tableData: [],
      totalCount: 0,
      userInfo: {},
      pageCount: 5,
      Current: 1
    };
  },
  created() {
    this.$nextTick(() => {
      this.Current = 1;
      this.getRecordList();
      this.getInfo();
    });
  },
  methods: {
    // 获取用户信息
    async getInfo() {
      let res = await getuserInfo();
      this.userInfo = res.data;
    },
    getRecordList(beginDate, endDate, pageNo, pageSize) {
      payOrder({ beginDate, endDate, pageNo, pageSize })
        .then(res => {
          if (res.success) {
            this.tableData = res.data.items;
            this.tableData.forEach(item => {
              item.yuanBi = `${item.yuanBi}源币`;
            });
            this.Current = Number(res.data.pageNum);
            this.totalCount = Number(res.data.totalCount);
          }
        })
        .catch(() => {});
    },
    timeBtn() {
      if (this.allChoooseTime) {
        this.getRecordList(
          this.allChoooseTime[0],
          this.allChoooseTime[1],
          1,
          10
        );
      } else {
        this.getRecordList("", "", 1, 10);
      }
    },
    currentChoose(pageNo) {
      if (this.allChoooseTime) {
        this.getRecordList(
          this.allChoooseTime[0],
          this.allChoooseTime[1],
          pageNo,
          10
        );
      } else {
        this.getRecordList("", "", pageNo, 10);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.incomebox
  padding 20px 24px
  .lineimgbox
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(211, 211, 211, 1)
    margin-bottom 20px
  .choosetime
    height 54px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(211, 211, 211, 1)
    line-height 54px
    margin-bottom 20px
    font-size 14px
    font-family PingFangSC-Regular
    font-weight 400
    color rgba(51, 51, 51, 1)
    .inquirebtn
      margin 13px 20px
    .userinfo
        margin-left 28px
        font-weight:600;
        color:rgba(154,154,154,1);
  .paginnation-book
    position absolute
    bottom 30px
    right 24px
</style>
